import { render, staticRenderFns } from "./exam-request-status.vue?vue&type=template&id=cf279860&"
import script from "./exam-request-status.vue?vue&type=script&lang=js&"
export * from "./exam-request-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports